const inputCls = "_086ijh6gss";

export { inputCls };
import "./SimpleInputReadonly.style.linaria.module.css";
//# sourceMappingURL=SimpleInputReadonly.style.js.map
